import { cn } from "@/lib/utils";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType;
}

const Container = ({ children, className, as: Component = "div" }: ContainerProps) => (
  <Component className={cn("container mx-auto", className)}>
    {children}
  </Component>
);

export default Container;
